import { render } from "./IndexPoint.vue?vue&type=template&id=885eddba&scoped=true"
import script from "./IndexPoint.vue?vue&type=script&lang=js"
export * from "./IndexPoint.vue?vue&type=script&lang=js"

import "./IndexPoint.vue?vue&type=style&index=0&id=885eddba&lang=scss&scoped=true"

import exportComponent from "/Users/user/workspace/okshop-diner/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-885eddba"]])

export default __exports__